
export const ContentHideApi = Symbol.for('ContentHideApi');


export interface ContentHideApiRequest {
    task_id: string;
    content_type: string;
    hidden: boolean
}

export interface ContentHideApi {
    contentHideApi(data: ContentHideApiRequest): void;
}
